import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=579abb36&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=579abb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579abb36",
  null
  
)

export default component.exports